namespace Nobox.CRM {
    export interface DealpipelinetypesForm {
        stgindex: Serenity.StringEditor;
        Active: Serenity.IntegerEditor;
        Name: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        Sequence: Serenity.StringEditor;
        LegendBlocked: Serenity.StringEditor;
        LegendDone: Serenity.StringEditor;
        LegendNormal: Serenity.StringEditor;
        MailTemplateId: Serenity.StringEditor;
        Fold: Serenity.IntegerEditor;
        RatingTemplateId: Serenity.StringEditor;
        AutoValidationKanbanState: Serenity.IntegerEditor;
        IsClosed: Serenity.IntegerEditor;
        UserId: Serenity.StringEditor;
        CreateUid: Serenity.StringEditor;
        CreateDate: Serenity.DateEditor;
        WriteUid: Serenity.StringEditor;
        WriteDate: Serenity.DateEditor;
        project_id: Serenity.StringEditor;
        ProjectName: Serenity.StringEditor;
    }

    export class DealpipelinetypesForm extends Serenity.PrefixedContext {
        static formKey = 'Nobox.Dealpipelinetypes';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DealpipelinetypesForm.init)  {
                DealpipelinetypesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DateEditor;

                Q.initFormType(DealpipelinetypesForm, [
                    'stgindex', w0,
                    'Active', w1,
                    'Name', w0,
                    'Description', w0,
                    'Sequence', w0,
                    'LegendBlocked', w0,
                    'LegendDone', w0,
                    'LegendNormal', w0,
                    'MailTemplateId', w0,
                    'Fold', w1,
                    'RatingTemplateId', w0,
                    'AutoValidationKanbanState', w1,
                    'IsClosed', w1,
                    'UserId', w0,
                    'CreateUid', w0,
                    'CreateDate', w2,
                    'WriteUid', w0,
                    'WriteDate', w2,
                    'project_id', w0,
                    'ProjectName', w0
                ]);
            }
        }
    }
}
